import { FormControl, InputLabel, ListSubheader, MenuItem, Select } from "@mui/material";
import { DOC_TYPE_GROUPS } from "./docTypes";

/**
 * Wspólny selektor „Typ dokumentu" dla połączonej listy „Dokumenty księgowe".
 * Używany w toolbarach trzech rejestrów (faktury / transakcje bankowe / polecenia
 * księgowania); zmiana wartości przełącza prezentowaną listę w komponencie-hoście.
 * Definicje grup/etykiet i helpery: ./docTypes.
 */

interface Props {
  value: string;
  onChange: (v: string) => void;
  minWidth?: number;
}

const DocTypeSelect = ({ value, onChange, minWidth = 200 }: Props) => (
  <FormControl size="small" sx={{ minWidth }}>
    <InputLabel>Typ dokumentu</InputLabel>
    <Select
      label="Typ dokumentu"
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      MenuProps={{ sx: { zIndex: 1500 } }}
    >
      {DOC_TYPE_GROUPS.flatMap((g) => [
        <ListSubheader key={g.group} sx={{ fontWeight: 700, color: "#5d49c7", lineHeight: "32px" }}>
          {g.header}
        </ListSubheader>,
        ...g.options.map((o) => (
          <MenuItem key={o.value} value={o.value} sx={{ pl: 3 }}>
            {o.label}
          </MenuItem>
        )),
      ])}
    </Select>
  </FormControl>
);

export default DocTypeSelect;
